<script>
import { mapActions } from 'vuex'
import * as Atlas3DViewer from '@/services/viewer'
import store from '@/store'
import JobSummary from './JobSummary'
import errorHandling from '../mixins/errorHandling'
import {jobDescription, defaultConfig} from '../services/helpers'

export default {
  name: 'ThreeJSViewer',
  components: {
    JobSummary
  },
  props: ['filename', 'source'],
  mixins: [errorHandling],
  data () {
    return {
      loading3JS: true,
      showOverlay: false,
      job: null,
      jobOutput: null,
      config: this.$route.params.createConfig,
      defaultConfig: Object.assign({}, defaultConfig),
      printersConfig: {},
      inputViewerData: {},
      jobDescription: null,
      jobOptimization: null,
      jobOptimizationNested: [],
      shouldPredict: this.$route.query.shouldPredict,
      viewer: null,
      creatingJob: false,
      message: 'Loading Siemens Viewer',
      file: null,
      restrictOrientation: false,
      restrictFaces: false,
      submitJobData: {},
      showSupportsOutput: false,
      showDirectionSelection: false,
      isHasSupports: false,
      isHasOptions: false,
      isStrengthenSupp: false,
      isHasOptionsFull: false,
      displacementDirection: 'z',
      displacementDirectionN: false,
      displacementOption: 'default',
      isCompensated: this.$route.query.compensated,
      isCanCompensate: false,
      isBladeCanCrush: false,
      isBladeCanCrushMessage: 'CAUTION: This build may cause a recoater blade crash!',
      layerThicknessCrushcoefficient: 10,
      contextMenu: false,
      contextMenuPosX: null,
      contextMenuPosY: null,
      currentPartName: '',
      modifySupportsMode: false,
      modifyMode: false,
      brushMode: true,
      brushRadius: 1,
      brushBothSide: false,
      selectionTolerance: 1.5,
      facetsSelection: 'erase',
      supportTransparency: 0.2,
      strengthenSupportTransparency: 0.7,
      nestedMode: false,
      platesConfig: [],
      allowZRotation: false,
      nestedJobs: null,
      partsConfig: {},
      platesErrors: false,
      nestedOptions: [],
      nestedPlate: 0,
      nestedPlates: [],
      isManualPlacement: false,
      legends: 0,
      legendsData: null,
      fileNames: [],
      nestedNames: [],
      isSupportUploaded: false,
      legendUpperLimit: null,
      legendLowerLimit: null,
      isNxUser: false
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   if (to.params.type === 'input') {
  //     if (store.state.createConfig) {
  //       store.dispatch('loadSourceFile', to.params.id).then(() => {
  //         next()
  //       }, () => {
  //         next({ name: 'Dash' })
  //       })
  //     } else {
  //       next({ name: 'CreateJob', params: to.params })
  //     }
  //   } else {
  //     next()
  //   }
  // },
  beforeRouteLeave (to, from, next) {
    if (this.viewer) {
      this.$nextTick(() => {
        this.viewer.destroy()
        this.viewer = null
        next()
      })
    } else {
      next()
    }
  },
  mounted () {
    this.$route.params.type === 'input' ? this.loadInputViewer() : this.loadOutputViewer()
    if (this.$route.params.restrictOrientation) {
      this.restrictOrientation = this.config.restrictOrientation = this.$route.params.restrictOrientation
    }
    if (this.$route.params.restrictFaces) {
      this.restrictFaces = this.config.restrictFaces = this.$route.params.restrictFaces
      // this.restrictFaces = this.config.restrictFaces = true
    }
    if (this.$route.params.submitJobData) {
      this.submitJobData = this.$route.params.submitJobData
    }
    if (this.$route.query.modifySupports) {
      this.modifySupportsMode = true
    }
    if (this.$route.query.token) {
      this.isNxUser = true
    }
  },
  computed: {
    isHasDistortionData () {
      return this.legends > 0
    }
  },
  methods: {
    ...mapActions({
      refreshCredits: 'user/refreshCredits'
    }),
    ...mapActions([
      'createJob',
      'submitJob',
      'updateJob',
      // 'getJobs',
      'getJob',
      'getNestedJobs',
      'getDownloadURL',
      'getURLData',
      'getJobOutputs',
      'generateSupport',
      'paintByCurvature',
      'getPrintConfig',
      'setNestedFileData',
      'updateNestedJob',
      'submitNestedJob'
    ]),
    changePanelEvents () {
      const panel = document.querySelector('.left-panel')
      const canvasElement = document.querySelector('#viewer3d')
      if (!panel || !canvasElement) return

      const redispatchEvent = (event) => canvasElement.dispatchEvent(new event.constructor(event.type, event))
      panel.addEventListener('contextmenu', (event) => event.preventDefault())
      panel.addEventListener('mousedown', redispatchEvent)
      panel.addEventListener('wheel', redispatchEvent)
      const panelBoxes = document.querySelectorAll('.left-panel__box')
      panelBoxes.forEach((item) => item.addEventListener('mousedown', (event) => event.stopPropagation()))
    },
    loadInputViewer () {
      this.getJob(this.$route.params.id)
        .then((response) => {
          const {isNested} = response.data.Job
          const promises = []
          this.job = response.data.Job
          if (isNested) {
            this.nestedMode = true
            this.nestedJobName = response.data.Job.nestedJobName
            this.config = this.job.config
            promises.push(this.getNestedJobs(this.$route.params.id))
          } else {
            promises.push(store.dispatch('loadSourceFile', { id: this.job.sourceFile.id, forceRefresh: false }))
          }
          return Promise.all(promises)
        })
        .then((response) => {
          if (this.nestedMode) {
            this.setNestedFileData(response[0].data.allJobs)
          }
          return this.getPrintConfig()
        })
        .then(({ data }) => {
          store.commit('SET_MATERIALS', data.config.materials)
          store.commit('SET_PRINTERS', data.config.printers)
          this.printersConfig = data.config.printers.reduce((acc, current) => {
            return Object.assign(this.printersConfig, {[current.name]: current})
          }, {})
        })
        .then(() => {
          let file
          if (this.nestedMode) {
            file = this.$store.state.filesNested[this.job.sourceFile.pathKey]
          } else {
            file = this.$store.state.files.find((f) => {
              return f.id === this.job.sourceFile.id
            })
          }
          if (!this.config) {
            this.config = this.job.config
          }
          if (this.config.filename_supp && this.config.filename_supp.length > 0) {
            this.isSupportUploaded = true
          }
          const filesUrl = []
          if (this.nestedMode) {
            const jobs = this.$store.state.filesNested
            this.isManualPlacement = this.config.manualPlacement
            for (let jobKey in jobs) {
              filesUrl.push(this.getDownloadURL({
                filename: jobs[jobKey].config.filename,
                sourceFilePathKey: jobs[jobKey].sourceFile.pathKey
              }))
            }
          } else {
            filesUrl.push(this.getDownloadURL({
              filename: this.config.filename,
              sourceFilePathKey: file.pathKey
            }))
            if (this.isSupportUploaded) {
              this.config.filename_supp.forEach((fileSupport) => {
                filesUrl.push(this.getDownloadURL({
                  sourceFilePathKey: file.pathKey,
                  jobPathKey: this.job.pathKey,
                  filename: fileSupport
                }))
              })
            }
          }
          Promise.all(filesUrl).then(response => {
            const parts = this.$store.state.filesNested
            const callbacks = {
              fetchSupport: () => {
                const {id} = this.$route.params
                const updateThisJob = { jobPathKey: id, config: {...this.config, needRemesh: false} }
                const submitThisJob = {
                  jobPathKey: id,
                  objectiveId: 0,
                  analysisId: 1
                }
                return this
                  .updateJob(updateThisJob)
                  .then(() => this.submitJob(submitThisJob))
                  .then(afterUpdate => {
                    // Dispatch getJob request
                    return store.dispatch('getJob', id)
                  })
                  .then(({data: {data: { Job }}}) => {
                    return store.dispatch('_jobs/getJobOutput', Job.jobOutputs[0].id)
                  })
                    // Parse outputFiles of Job
                  .then(response => {
                    const {data: {data: { JobOutput: jobOutput }}} = response
                    return {
                      jobOutputPathKey: jobOutput.pathKey,
                      jobPathKey: jobOutput.job.pathKey,
                      sourceFilePathKey: jobOutput.job.sourceFile.pathKey
                    }
                  })
                  .then(jobOutputFiles => {
                    // Download the url of STL file
                    const filename = '1_cube_0m.stl'
                    const stlConfig = Object.assign({}, jobOutputFiles, {
                      filename
                    })
                    return this.getDownloadURL(stlConfig)
                  })
                  .catch((err) => {
                    this.errorHandling(err, location.reload)
                  })
              },
              generateSupportExternal: (partParams) => {
                this.config.RotationalAngle = partParams.rotation
                this.config.scaling = partParams.scaling
                this.config.unit = partParams.units
                this.config.AllowedFaces = partParams.AllowedFaces
                this.config.RestrictedFaces = partParams.RestrictedFaces
                return this.generateSupport({
                  sourceFilePathKey: file.pathKey,
                  config: this.config
                })
              },
              getCurvaturePerFaceData: () => {
                const getData = (url, attempt) => {
                  return new Promise((resolve, reject) => {
                    return this.getURLData({url})
                      .then((response) => {
                        resolve(response.data)
                      })
                      .catch((err) => {
                        if (err.response &&
                          err.response.status &&
                          err.response.status === 404 &&
                          attempt <= 20) {
                          attempt++
                          let delay = 1500 * attempt
                          if (attempt > 3) {
                            delay = 8000
                          }
                          setTimeout(() => {
                            resolve(getData(url, attempt))
                          }, delay)
                        } else {
                          reject(err)
                        }
                      })
                  })
                }
                return new Promise((resolve, reject) => {
                  this.paintByCurvature({
                    sourceFilePathKey: file.pathKey,
                    config: this.config
                  })
                    .then((response) => {
                      return getData(response.data.url, 1)
                    })
                    .then((response) => {
                      resolve(response)
                    })
                    .catch((err) => {
                      reject(err)
                    })
                })
              },
              supportLoading: (toggle) => {
                if (toggle) {
                  this.loading3JS = true
                  this.message = 'Loading support structure'
                } else {
                  this.loading3JS = false
                }
              },
              curvatureLoading: (toggle) => {
                if (toggle) {
                  this.loading3JS = true
                  this.message = 'Preparing for selection of flat surface...'
                } else {
                  this.loading3JS = false
                }
              },
              contextMenuToggle: (toggle, mouse) => {
                if (this.isSupportUploaded) return
                this.contextMenu = toggle
                if (mouse) {
                  if (window.innerWidth - mouse.x <= this.$refs.cMenu.clientWidth && window.clientHeight - mouse.y <= this.$refs.cMenu.clientHeight) {
                    this.contextMenuPosX = window.innerWidth - this.$refs.cMenu.clientWidth
                    this.contextMenuPosY = window.innerHeight - this.$refs.cMenu.clientHeight
                  } else if (window.innerWidth - mouse.x <= this.$refs.cMenu.clientWidth) {
                    this.contextMenuPosX = window.innerWidth - this.$refs.cMenu.clientWidth
                    this.contextMenuPosY = mouse.y
                  } else if (window.clientHeight - mouse.y <= this.$refs.cMenu.clientHeight) {
                    this.contextMenuPosX = mouse.x
                    this.contextMenuPosY = window.innerHeight - this.$refs.cMenu.clientHeight
                  } else {
                    this.contextMenuPosX = mouse.x
                    this.contextMenuPosY = mouse.y
                  }
                }
              },
              showHelp: () => {
                this.$modal.show('dialoghelp')
              },
              changeZRotationAccess: (value) => {
                if (value) {
                  this.$modal.show('zrotationmodal')
                } else {
                  for (let name in this.partsConfig) {
                    const [x, y] = this.partsConfig[name].RotationalAngle
                    this.partsConfig[name].RotationalAngle = [x, y, 0]
                  }
                  this.changeZRotation(false)
                }
              },
              savePartsConfig: (data) => {
                const parts = this.$store.state.filesNested
                for (let key in parts) {
                  const pathKey = parts[key].sourceFile.pathKey
                  const name = parts[key].config.filename
                  store.commit('SET_NESTED_FILE_CONFIG', {
                    pathKey,
                    config: data[name]
                  })
                }
              },
              savePlatesConfig: (platesConfig) => {
                this.config.manualTransform = []
                let isErrors = false
                this.platesConfig = platesConfig.reduce((acc, plate, inx) => {
                  if (Object.keys(plate).length > 1) {
                    const index = acc.length + 1
                    const plateName = `plate ${index}`
                    const namedPlate = {[plateName]: plate}
                    acc.push(namedPlate)
                    if (plate.errors) isErrors = true
                  }
                  return acc
                }, [])
                this.platesErrors = isErrors
              },
              openRemovePlateModal: () => {
                this.$modal.show('removeplatemodal')
              }
            }
            const files = {parts: []}
            const configs = {
              config: this.config,
              printersConfig: this.printersConfig
            }
            if (this.nestedMode) {
              const partsNames = []
              response.forEach(({config, data}) => {
                const {sourceFilePathKey} = JSON.parse(config.data)
                const name = parts[sourceFilePathKey].config.filename
                store.commit('SET_NESTED_FILE_URL', {url: data.url, sourceFilePathKey})
                files.parts.push(data.url)
                partsNames.push(name)
                this.partsConfig[name] = parts[sourceFilePathKey].config
              })
              const nestedConfig = {allowZRotation: this.allowZRotation, partsNames, isManualPlacement: this.isManualPlacement, partsConfig: this.partsConfig, margin: {marginX: this.config.marginX[0], marginY: this.config.marginY[0]}}
              configs.nestedConfig = nestedConfig
              configs.config = Object.entries(this.partsConfig)[0][1]
            } else {
              files.parts.push(response[0].data.url)
              files.supports = response.length > 1 && !this.config.isHideSupports
                ? response.filter((r, index) => index > 0).map(r => r.data.url)
                : []
            }
            this.viewer = new Atlas3DViewer.InputViewer(configs, files, () => {
              this.$nextTick(() => {
                this.viewer.init()
                this.viewer.animate()
                this.contextMenu = this.viewer.contextMenu
              })
            }, () => {
              this.loading3JS = false
            }, (data) => {
              this.inputViewerData = data
              this.showSummary()
            },
            callbacks)
          })
        })
    },
    changeZRotation (value) {
      this.allowZRotation = value
      this.viewer.changeAllowZRotation(value)
      this.$modal.hide('zrotationmodal')
    },
    removePlate (value) {
      this.viewer.onRemovePlate(value)
      this.$modal.hide('removeplatemodal')
    },
    loadOutputViewer () {
      this.getPrintConfig()
        .then(({ data }) => {
          store.commit('SET_MATERIALS', data.config.materials)
          store.commit('SET_PRINTERS', data.config.printers)
          this.printersConfig = data.config.printers.reduce((acc, current) => {
            return Object.assign(this.printersConfig, {[current.name]: current})
          }, {})
          return store.dispatch('_jobs/getJobOutput', this.$route.params.id)
        })
        .then((response) => {
          this.jobOutput = response.data.JobOutput
          this.isManualPlacement = this.jobOutput.job.config.manualPlacement
          this.job = this.jobOutput.job

          if (this.job.config.hasOwnProperty('filename_supp') && this.job.config.filename_supp.length > 0) {
            this.isSupportUploaded = true
          }

          if (this.job.config && this.job.config.isCompensate && this.job.config.isCompensate[0]) {
            this.isCanCompensate = false
          } else {
            this.isCanCompensate = true
          }

          if (this.job.isNested) {
            return store.dispatch('_jobs/getNestedJobs', this.job.pathKey)
          } else {
            this.jobOptimization = jobDescription(
              this.jobOutput.analysisId,
              this.jobOutput.objectiveId,
              this.isCompensated,
              true
            )
            return null
          }
        })
        .then((nestedJobs) => {
          const baseConfig = {
            jobOutputPathKey: this.jobOutput.pathKey,
            jobPathKey: this.job.pathKey,
            sourceFilePathKey: this.job.sourceFile.pathKey
          }
          const uploadedFileConfig = {
            sourceFilePathKey: this.job.sourceFile.pathKey
          }
          const uploadedSuppConfig = {
            jobPathKey: this.job.pathKey,
            sourceFilePathKey: this.job.sourceFile.pathKey
          }
          const promises = []
          const stlFiles = []
          const stlFilesCompensated = []
          const jsonConfig = []
          const binConfig = []
          const binConfigCompensated = []
          const suppFiles = []
          const suppFilesCompensated = []
          const legendConfig = []
          const nestedConfig = []
          const nestedPlateConfig = []
          const recoaterWarning = []

          if (nestedJobs) {
            this.nestedJobs = nestedJobs.data.allJobs
            nestedPlateConfig.push(this.job.config)
            this.job.config = this.nestedJobs[0].config
          }
          const checkSupports = (names) => {
            const isRenishawPrinter = this.job.config.printer.match(/Renishaw/)
            let newNames = names.filter(name => {
              const isReneshawSupp = isRenishawPrinter && name.match(/Renishaw/)
              const isOtherSupp = !isRenishawPrinter && !name.match(/Renishaw/)
              if (name.match(/strengthen/)) {
                this.isStrengthenSupp = true
                return true
              } if (name.match(/polymer/)) {
                return false
              } if (isReneshawSupp || isOtherSupp) {
                return true
              }
            })
            return newNames
          }
          let outputFiles = {}
          this.jobOutput.outputFiles.forEach((file) => {
            if (!outputFiles.hasOwnProperty(file.name)) {
              outputFiles[file.name] = true
              if ((file.name.match(/_([XYN])?output\.stl$/) && !file.name.match(/_output_compensated\.stl$/)) || file.name.match(/_new\.stl$/)) {
                if (this.isSupportUploaded) {
                  stlFiles.push(Object.assign({filename: this.job.config.filename}, uploadedFileConfig))
                } else {
                  stlFiles.push(Object.assign({filename: file.name}, baseConfig))
                }
              }
              if (file.name.match(/_output_compensated\.stl$/)) {
                stlFilesCompensated.push(Object.assign({filename: file.name}, baseConfig))
              }
              if (file.name.match(/legend(_[xyN])?\.json$/)) {
                legendConfig.push(Object.assign({filename: file.name}, baseConfig))
              }
              if (file.name.match(/disp_config\.json$/)) {
                jsonConfig.push(Object.assign({filename: file.name}, baseConfig))
              }
              if (file.name.match(this.job.config.isStrengthSupp && this.job.config.isStrengthSupp[0]
                   ? /disp_config_strengthen_supp$/
                   : /disp_config$/)) {
                binConfig.push(Object.assign({filename: file.name}, baseConfig))
              }
              if (file.name.match(/disp_config_compensated$/)) {
                binConfigCompensated.push(Object.assign({filename: file.name}, baseConfig))
              }
              if (file.name.match(/_0m\.stl$/) && !file.name.match(/_compensated_0m\.stl$/)) {
                if (this.isSupportUploaded) {
                  this.job.config.filename_supp.forEach(fileSupp => {
                    suppFiles.push(Object.assign({filename: fileSupp}, uploadedSuppConfig))
                  })
                  this.isHasSupports = true
                } else {
                  suppFiles.push(Object.assign({filename: file.name}, baseConfig))
                  this.isHasSupports = true
                }
              }
              if (file.name.match(/_compensated_0m\.stl$/)) {
                suppFilesCompensated.push(Object.assign({filename: file.name}, baseConfig))
              }
              if (file.name.match(/Config_nesting.json$|configNesting.json$/)) {
                nestedConfig.push(Object.assign({filename: file.name}, baseConfig))
                this.nestedMode = true
              }
              if (file.name.match(/warningMessage.json$/)) {
                recoaterWarning.push(Object.assign({filename: file.name}, baseConfig))
              }
            }
          })
          if (this.nestedMode) {
            this.nestedJobs.forEach((job) => {
              const nestedBaseConfig = {
                jobOutputPathKey: job.jobOutputs[0].pathKey,
                jobPathKey: job.pathKey,
                sourceFilePathKey: job.sourceFile.pathKey
              }
              const outputFiles = job.jobOutputs[0].outputFiles
              const outputFilesKeys = {}
              outputFiles.forEach((file) => {
                if (!outputFilesKeys.hasOwnProperty(file.name)) {
                  outputFilesKeys[file.name] = true
                  if (file.name.match(/_output\.stl$/) && !file.name.match(/_compensated_output\.stl$/)) {
                    stlFiles.push(Object.assign({filename: file.name}, nestedBaseConfig))
                    this.fileNames.push(file.name)
                    this.jobOptimizationNested.push(jobDescription(
                      job.jobOutputs[0].analysisId,
                      job.jobOutputs[0].objectiveId,
                      false,
                      true
                    ))
                  }
                  if (file.name.match(/_0m\.stl$/) &&
                    !file.name.match(/_compensated_0m\.stl$/) &&
                    !file.name.match(/^1_.*_Renishaw_0m\.stl$/) &&
                    !file.name.match(/_compensated_Renishaw_0m\.stl$/)) {
                    suppFiles.push(Object.assign({filename: file.name}, nestedBaseConfig))
                    this.isHasSupports = true
                  }
                  if (file.name.match(/Renishaw|strengthen\.stl/)) {
                    suppFiles.push(Object.assign({filename: file.name}, nestedBaseConfig))
                  }
                  if (file.name.match(/disp_config$/)) {
                    binConfig.push(Object.assign({filename: file.name}, nestedBaseConfig))
                  }
                }
              })
            })
          }

          if (this.isCompensated) {
            promises.push(this.getFileUrl(stlFilesCompensated))
            promises.push(this.getFileUrl(suppFilesCompensated))
          } else {
            promises.push(this.getFileUrl(stlFiles))
            const supportFiles = suppFiles.reduce((acc, curr) => {
              if (!acc[curr.filename]) {
                acc[curr.filename] = curr
              }
              return acc
            }, {})
            const newNames = checkSupports(Object.keys(supportFiles))
            promises.push(this.getFileUrl(newNames.map((filename) => supportFiles[filename])))
          }

          if (legendConfig.length > 0) {
            legendConfig.push(legendConfig.shift())
          }

          promises.push(this.getFileData(legendConfig))
          promises.push(this.getFileData(jsonConfig))
          if (this.isCompensated) {
            promises.push(this.getFileData(binConfigCompensated, true))
          } else {
            promises.push(this.getFileData(binConfig, true))
          }
          promises.push(this.getFileData(nestedConfig))
          promises.push(nestedPlateConfig)
          promises[7] = this.getFileData(recoaterWarning)

          Promise.all(promises).then((responses) => {
            if (responses[2]) {
              this.legends = 1
            }

            if (responses[5] ||
              (responses[2] && (responses[2].length === 3 || responses[2].length === 4)) ||
              (responses[3] && responses[3][0].dispZ) ||
              responses[4]) {
              this.legends = 1
              this.showDirectionSelection = true
              this.displacementDirectionN = (responses[5] ||
                (responses[2] && responses[2].length === 4) ||
                (responses[3] && responses[3][0].dispZ) ||
                responses[4])
              if (this.displacementDirectionN) {
                this.displacementDirection = 'n'
              }
            }

            let nestedPositionWithRotation = false

            if (responses[5]) {
              if (responses[5][0] &&
                 (responses[5][0].hasOwnProperty('nesting2d') ||
                 responses[5][0].hasOwnProperty('nesting2dWithRotation'))) {
                const nestingData = responses[5][0].hasOwnProperty('nesting2d')
                  ? responses[5][0].nesting2d
                  : responses[5][0].nesting2dWithRotation
                nestedPositionWithRotation = !!responses[5][0].nesting2dWithRotation
                const partsPositions = nestingData.reduce((result, currentPlate, index) => {
                  result['plate' + index] = currentPlate
                  return result
                }, {})
                responses[5] = partsPositions
              } else {
                responses[5] = responses[5][0]
              }
              this.nestedPlates = Object.keys(responses[5])
              this.nestedOptions = this.nestedPlates.concat(this.fileNames)
              this.nestedNames = this.nestedOptions.map((file, inx) => {
                if (file.match(/^plate[0-9]+$/)) return `Build plate #${inx + 1}`
                return file
              })
              this.currentPartName = this.nestedNames[0]
              this.legends = responses[0].length
            }

            const files = {
              parts: responses[0],
              support: responses[1],
              legend: responses[2],
              displayConfig: responses[3],
              nestedPositionConfig: responses[5],
              nestedPlateConfig: responses[6]
            }

            if (responses[4] && responses[4].length > 0) {
              files.displayConfigBinary = responses[4]
            }

            if (this.isCompensated && !(responses[0] && responses[1])) {
              this.$router.replace({name: 'ThreeJSViewer', params: {id: this.jobOutput.id, type: 'output'}})
              return
            }

            const configs = {
              config: this.jobOutput.job.config,
              printersConfig: this.printersConfig,
              nestedPositionWithRotation,
              isManualPlacement: this.isManualPlacement
            }

            const callbacks = {
              init: () => {
                this.$nextTick(() => {
                  this.viewer.switchModifySupportsMode(this.modifySupportsMode)
                  this.viewer.init()
                  this.changePanelEvents()
                  if (this.isSupportUploaded) {
                    this.viewer.uploadedSupport = true
                  }
                  if (this.modifySupportsMode) {
                    this.viewer.addEventListeners()
                  }
                  this.viewer.animate()
                })
              },
              finishedLoading: (data) => {
                this.isHasOptionsFull = !!data.isHasOptionsFull
                if (!this.isHasOptionsFull) {
                  this.displacementOption = 'on'
                  this.viewer.switchDistortionOption('on')
                }
                if (this.displacementDirectionN && !this.modifySupportsMode) {
                  this.viewer.switchDistortion('n')
                }

                if ((responses[4] || (responses[3] && responses[3][0].dispLegendZ)) && !this.nestedMode) {
                  if (responses[7] && responses[7][0] && responses[7][0].hasOwnProperty('warning_message')) {
                    if (responses[7][0].warning_message) {
                      this.isBladeCanCrush = true
                      this.isBladeCanCrushMessage = responses[7][0].warning_message
                    } else {
                      this.isBladeCanCrush = false
                    }
                  } else {
                    this.isBladeCanCrush = this.checkIsBladeCanCrush(
                      this.job.config.layerThickness[0],
                      data.maxDistortion
                    )
                  }
                } else if (this.nestedMode) {
                  this.isBladeCanCrush = null
                  this.legendsData = data.legendsData
                  this.checkIsBladeCanCrushNested()
                }

                if (data.hasOwnProperty('isHasOptions')) {
                  this.isHasOptions = data.isHasOptions
                }

                if (this.modifySupportsMode) {
                  this.modifySupportStructures()
                }
                this.loading3JS = false
              },
              getCurvaturePerFaceData: () => {
                const getData = (url, attempt) => {
                  return new Promise((resolve, reject) => {
                    return this.getURLData({url})
                      .then((response) => {
                        resolve(response.data)
                      })
                      .catch((err) => {
                        if (err.response &&
                          err.response.status &&
                          err.response.status === 404 &&
                          attempt <= 30) {
                          attempt++
                          let delay = 1500 * attempt
                          if (attempt > 10) {
                            delay = 30000
                          } else if (attempt > 3) {
                            delay = 8000
                          }
                          setTimeout(() => {
                            resolve(getData(url, attempt))
                          }, delay)
                        } else {
                          reject(err)
                        }
                      })
                  })
                }
                return new Promise((resolve, reject) => {
                  this.paintByCurvature({
                    sourceFilePathKey: this.job.sourceFile.pathKey,
                    config: this.job.config
                  })
                    .then((response) => {
                      return getData(response.data.url, 1)
                    })
                    .then((response) => {
                      resolve(response)
                    })
                    .catch((err) => {
                      reject(err)
                    })
                })
              },
              curvatureLoading: (toggle) => {
                if (toggle) {
                  this.loading3JS = true
                  this.message = 'Preparing for selection of flat surface...'
                } else {
                  this.loading3JS = false
                }
              },
              switchBrushModeCallback: () => {
                this.brushMode = true
              }
            }

            this.viewer = new Atlas3DViewer.OutputViewer(configs, files, callbacks)
          })
        })
        .catch((err) => {
          this.errorHandling(err, location.reload)
        })
    },
    showSummary () {
      if (!this.nestedMode) {
        this.viewer.updateConfig(this.inputViewerData, this.config)
        this.$modal.show('summarymodal')
      } else {
        this.$modal.show('summarynestedmodal')
      }
    },
    submitInput (jobDescription = '') {
      this.jobDescription = jobDescription
      this.creatingJob = true
      this.showOverlay = true
      this.message = 'Creating Job'
      delete this.config.restrictOrientation
      delete this.config.restrictFaces
      let promise = () => this.updateJob({
        jobPathKey: this.$route.params.id,
        config: {...this.config, needRemesh: false},
        jobDescription
      })
      .then(response => {
        this.message = 'Submitting Job'
        return this.submitJob({
          jobPathKey: response.data.jobPathKey,
          objectiveId: 0,
          analysisId: this.shouldPredict ? 3 : 1
        })
      })
      if (!this.nestedMode && (this.restrictOrientation || this.restrictFaces)) {
        promise = () => this.updateJob({
          jobPathKey: this.submitJobData.jobPathKey,
          config: {...this.config, needRemesh: false},
          jobDescription
        })
        .then(response => {
          this.message = 'Submitting job'
          return this.submitJob({
            jobPathKey: response.data.jobPathKey,
            objectiveId: this.submitJobData.objectiveId,
            analysisId: this.submitJobData.analysisId
          })
        })
      }
      if (this.nestedMode) {
        this.$modal.hide('summarynestedmodal')
        if (this.allowZRotation) {
          this.config.deltaR = [360]
        }
        if (this.isManualPlacement) {
          if (!this.platesConfig.length) return
          this.config.manualTransform = []
          this.platesConfig.forEach((plate, inx) => {
            const name = Object.keys(plate)
            delete this.platesConfig[inx][name].errors
            this.config.manualTransform.push(this.platesConfig[inx])
          })
        }
        const parts = this.$store.state.filesNested
        const nestedJobs = Object.values(parts).map(file => ({
          config: file.config,
          jobPathKey: file.jobPathKey
        }))
        promise = () => this.updateJob({
          config: {...this.config, needRemesh: false},
          jobPathKey: this.job.pathKey,
          jobDescription: ''
        })
        .then(() => this.updateNestedJob({
          nestedJobs,
          nestedJobName: this.nestedJobName,
          parentPathKey: this.job.pathKey
        }))
        .then(response => {
          this.message = 'Submitting Job'
          const partsData = response.data.map(file => ({
            jobPathKey: file.jobPathKey,
            objectiveId: 0,
            analysisId: 3
          }))
          return this.submitNestedJob(partsData)
        })
      }
      promise()
      .then(success => {
        this.inputViewerData.viewer.destroy()
        this.viewer = null
        this.refreshCredits()
        this.$router.replace({name: 'Dash'})
      })
      .catch((err) => {
        this.showOverlay = false
        this.creatingJob = false
        this.errorHandling(err, () => {
          this.$modal.show('summarymodal')
        })
      })
    },
    getFileUrl (config) {
      if (config.length > 0) {
        return Promise.all(config.map((file) => {
          return this.getDownloadURL(file).then(response => response.data.url)
        }))
      } else {
        return null
      }
    },
    getFileData (config, binary) {
      if (config.length > 0) {
        return Promise.all(config.map((file) => {
          return this.getDownloadURL(file)
            .then((response) => {
              if (binary) {
                return this.getURLData({url: response.data.url, binary: true})
              } else {
                return this.getURLData({url: response.data.url})
              }
            })
            .then((data) => {
              return data.data
            })
        }))
      } else {
        return null
      }
    },
    toggleSupports () {
      if (this.showSupportsOutput) {
        this.viewer.HideSupp()
      } else {
        this.viewer.ShowSupp()
        this.loading3JS = true
        this.message = 'Loading support structure'
        setTimeout(() => {
          this.viewer.ShowSupp().then(() => {
            this.loading3JS = false
          })
        }, 50)
      }
      this.showSupportsOutput = !this.showSupportsOutput
    },
    switchDistortionOption (option) {
      if (option === 'on') {
        this.viewer.addSupport()
      } else {
        this.viewer.removeSupport()
      }
      this.viewer.switchDistortionOption(option)
    },
    modifySupportStructures () {
      this.modifyMode = !this.modifyMode
      this.viewer.modifyMode = this.modifyMode
      this.showSupportsOutput = true
      if (this.modifyMode) {
        this.viewer.HideSupp()
      } else {
        this.loading3JS = true
        this.message = 'Loading support structure'
        setTimeout(() => {
          this.viewer.ShowSupp().then(() => {
            this.loading3JS = false
          })
        }, 50)
      }
    },
    cMenuParallel () {
      this.viewer.makeParallelToBuildPlate()
    },
    generateSupportStructures () {
      this.$modal.hide('modifycaution')
      const sourceFilePathKey = this.jobOutput.job.sourceFile.pathKey
      const outputFilePathKey = this.jobOutput.pathKey
      let filename
      this.jobOutput.outputFiles.forEach((file) => {
        if (file.name.match(/_output\.stl$/)) {
          filename = file.name
        }
      })
      const config = Object.assign(this.defaultConfig, this.jobOutput.job.config)
      config.AllowedFaces = this.viewer.getAllowedFaces()
      config.RestrictedFaces = this.viewer.getRestrictedFaces()
      config.RotationalAngle = [0, 0, 0]
      config.filename = filename
      config.unit = 'mm'
      config.scaling = [1]
      this.creatingJob = true
      this.showOverlay = true
      this.message = 'Generating support structures'

      this.createJob({
        sourceFilePathKey,
        config
      })
      .then((response) => {
        return this.submitJob({
          jobPathKey: response.data.jobPathKey,
          outputFilePathKey,
          filename,
          objectiveId: 0,
          analysisId: 99
        })
      })
      .then((response) => {
        this.viewer.destroy()
        this.viewer = null
        this.refreshCredits()
        this.$router.replace({name: 'Dash'})
      })
      .catch((err) => {
        this.creatingJob = false
        this.showOverlay = false
        this.errorHandling(err, this.generateSupportStructures)
      })
    },
    generateCompensated () {
      const sourceFilePathKey = this.jobOutput.job.sourceFile.pathKey
      const config = Object.assign(this.defaultConfig, this.jobOutput.job.config)
      config.isCompensate[0] = 1
      this.creatingJob = true
      this.showOverlay = true
      this.message = 'Generating compensated STL'

      this.createJob({
        sourceFilePathKey,
        config
      })
      .then((response) => {
        return this.submitJob({
          jobPathKey: response.data.jobPathKey,
          objectiveId: this.jobOutput.objectiveId,
          analysisId: this.jobOutput.analysisId
        })
      })
      .then((response) => {
        this.viewer.destroy()
        this.viewer = null
        this.refreshCredits()
        this.$router.replace({name: 'Dash'})
      })
      .catch((err) => {
        this.creatingJob = false
        this.showOverlay = false
        this.errorHandling(err, this.generateCompensated)
      })
    },
    convertUnits (unit) {
      return unit * 1000
    },
    switchBuildPlate () {
      const fileIndex = this.nestedPlate - this.nestedPlates.length
      this.currentPartName = this.nestedNames[this.nestedPlate]
      if (fileIndex > -1) {
        this.jobOptimization = this.jobOptimizationNested[fileIndex]
        if (this.legendsData && this.legendsData[fileIndex]) {
          this.isBladeCanCrush = this.checkIsBladeCanCrush(
            this.jobOutput.job.config.layerThickness[0],
            this.legendsData[fileIndex][1]
          )
        }
      } else {
        this.checkIsBladeCanCrushNested()
        this.jobOptimization = null
      }
      this.viewer.switchNestedPlates(this.nestedOptions[this.nestedPlate])
    },
    switchFacetSelectionMode (mode) {
      this.viewer.switchFacetSelectionMode(mode)
    },
    switchBrushMode () {
      this.viewer.switchBrushMode(this.brushMode)
      if (!this.brushMode && this.brushBothSide) {
        this.brushBothSide = false
        this.viewer.switchBrushSide(this.brushBothSide)
      }
    },
    switchBrushSide () {
      this.viewer.switchBrushSide(this.brushBothSide)
      if (this.brushBothSide && !this.brushMode) {
        this.brushMode = true
        this.viewer.switchBrushMode(this.brushMode)
      }
    },
    setBrushRadius (event) {
      this.viewer.setBrushRadius(event)
    },
    setSupportTransparency (event, isStrength) {
      this.viewer.setSupportTransparency(event, isStrength)
    },
    setSelectionTolerance (event) {
      this.viewer.setSelectionTolerance(event)
    },
    resetFaces () {
      this.viewer.resetFaces()
    },
    checkLegend (index) {
      if (this.nestedPlate >= this.nestedPlates.length) {
        return this.fileNames[index] === this.nestedOptions[this.nestedPlate]
      } else {
        return true
      }
    },
    checkIsBladeCanCrush (layerThickness, maxDistortion) {
      return maxDistortion > (layerThickness / 1000) * this.layerThicknessCrushcoefficient
    },
    checkIsBladeCanCrushNested () {
      this.isBladeCanCrush = null
      this.legendsData.forEach((legend) => {
        if (this.checkIsBladeCanCrush(this.job.config.layerThickness[0], legend[1])) {
          this.isBladeCanCrush = true
        }
      })
    }
  }
}
</script>

<template>
  <div :class="{ 'loading-styles': creatingJob || loading3JS}">
    <div id="inset"></div>
    <div v-if='creatingJob || loading3JS' class="preloader" :class="{'overlay': showOverlay}">
      <div style='width:50%;text-align:center;'>
        <h5>{{message}}</h5>
        <div class='progress'>
          <div class='indeterminate'>
          </div>
        </div>
      </div>
    </div>
    <template v-if='$route.params.type==="input" && !this.isSupportUploaded'>
      <div class="context-menu" ref="cMenu" v-show="contextMenu" :style="{'top': contextMenuPosY + 'px', 'left': contextMenuPosX + 'px'}">
          <ul>
              <li>
                  <a @click="cMenuParallel()">Make parallel to build plate</a>
              </li>
          </ul>
      </div>
      <div id="info" v-show='!(loading3JS || creatingJob) && !isSupportUploaded'>
        <div class="info-text">
        <span v-if="!nestedMode">Check "Support structures" to generate support;</span>
        Check "Orient Model" to scale and/or orient part.</div>
      </div>
      <div id="bottom-legend" v-show='!(loading3JS || creatingJob) && !isSupportUploaded'>
        <div class="info-text" v-if="!nestedMode">To orient your part, simply grab anywhere around the part with your mouse and drag your mouse until you
        have oriented it the way you would like. Dragging UP or DOWN will rotate the part about the screen's horizontal direction.
        Dragging LEFT or RIGHT will rotate the part about the screen's vertical direction.</div>
      </div>
    </template>
    <template v-else>
      <div class="bottom-block" :class="{'single-legend': legends < 2}" @click.stop>
        <div class="controls-box modify-supports" v-if="modifyMode">
          <p class="title">Facets selection</p>
          <p>
            <input name="facetsSelection"
                   type="radio"
                   id="restrictFace"
                   v-model="facetsSelection"
                   @change="switchFacetSelectionMode('restrict')"
                   value="restrict"/>
            <label for="restrictFace">Remove Supports</label>
          </p>
          <p>
            <input name="facetsSelection"
                   type="radio"
                   id="allowFace"
                   v-model="facetsSelection"
                   @change="switchFacetSelectionMode('allow')"
                   value="allow"/>
            <label for="allowFace">Add Support Structures</label>
          </p>
          <p>
            <input name="facetsSelection"
                   type="radio"
                   id="eraseFace"
                   v-model="facetsSelection"
                   @change="switchFacetSelectionMode('erase')"
                   value="erase"/>
            <label for="eraseFace">Erase Support Modification</label>
          </p>
          <p>
            <input name="brushMode"
                   type="checkbox"
                   id="brushMode"
                   v-model="brushMode"
                   @change="switchBrushMode()"
                   class="filled-in"/>
            <label for="brushMode">Brush Mode</label>
          </p>
          <p>
            <input name="brushBothSide"
                   type="checkbox"
                   id="brushBothSide"
                   v-model="brushBothSide"
                   @change="switchBrushSide()"
                   class="filled-in"/>
            <label for="brushBothSide">Brush paints on both sides</label>
          </p>
          <div class="range-bar" v-if="!brushMode">
            <div class="range-bar-slider">
              <label for="selectionTolerance">Tolerance</label>
              <input name="selectionTolerance"
                     type="range"
                     id="selectionTolerance"
                     v-model="selectionTolerance"
                     min="0.1"
                     max="5"
                     step="0.1"
                     @change="setSelectionTolerance($event)"/>
            </div>
            <div class="range-bar-value">
              <input type="number"
                     v-model="selectionTolerance"
                     min="0.1"
                     max="5"
                     step="0.1"
                     @change="setBrushRadius($event)"/>
            </div>
          </div>
          <div class="range-bar" v-if="brushMode">
            <div class="range-bar-slider">
              <label for="brushRadius">Brush Radius</label>
              <input name="brushRadius"
                     type="range"
                     id="brushRadius"
                     v-model="brushRadius"
                     min="0.1"
                     max="5"
                     step="0.1"
                     @change="setBrushRadius($event)"/>
            </div>
            <div class="range-bar-value">
              <input type="number"
                     v-model="brushRadius"
                     min="0.1"
                     max="5"
                     step="0.1"
                     @change="setBrushRadius($event)"/>
            </div>
          </div>
          <div class="range-bar">
            <div class="range-bar-slider">
              <label for="supportTransparency">Support Transparency</label>
              <input name="supportTransparency"
                     type="range"
                     id="supportTransparency"
                     v-model="supportTransparency"
                     min="0"
                     max="1"
                     step="0.01"
                     @input="setSupportTransparency($event)"/>
            </div>
            <div class="range-bar-value">
              <input type="number"
                     v-model="supportTransparency"
                     min="0"
                     max="1"
                     step="0.01"
                     @change="setSupportTransparency($event)"/>
            </div>
          </div>
          <div class="range-bar" v-if="this.isStrengthenSupp">
            <div class="range-bar-slider">
              <label for="StrengthenSupportTransparency">Strengthen Supp Transparency</label>
              <input name="StrengthenSupportTransparency"
                     type="range"
                     id="StrengthenSupportTransparency"
                     v-model="strengthenSupportTransparency"
                     min="0"
                     max="1"
                     step="0.01"
                     @input="setSupportTransparency($event, true)"/>
            </div>
            <div class="range-bar-value">
              <input type="number"
                     v-model="strengthenSupportTransparency"
                     min="0"
                     max="1"
                     step="0.01"
                     @change="setSupportTransparency($event, true)"/>
            </div>
          </div>
          <div class="button-block center-align">
            <button class="a3d btn inv" @click="$modal.show('modifycaution')">Generate supports</button>
          </div>
          <div class="button-block center-align">
            <button class="a3d btn inv" @click="resetFaces()">Reset selection</button>
          </div>
        </div>
      </div>
      <div class="left-panel" v-show="!modifySupportsMode && isHasSupports && showDirectionSelection && isHasOptions">
        <div class="buttons-block" v-if="!(creatingJob || loading3JS)">
          <div v-if="nestedMode">
            <select class="browser-default" v-model="nestedPlate" @change="switchBuildPlate()">
                <template v-for="(plate, index) of nestedNames">
                    <option :value="index" :key="plate">{{plate}}</option>
                </template>
            </select>
          </div>
          <button class='a3d btn btn-large no-wrap'
                  @click='viewer.reset()'>Reset View</button>
          <button class='a3d btn btn-large no-wrap'
                  style='width: 220px'
                  v-if="isHasSupports && !modifySupportsMode && isHasDistortionData"
                  :disabled="modifyMode"
                  @click='toggleSupports()'>{{showSupportsOutput ? 'Show distortion' : 'Show Support'}}</button>
        </div>
        <div class="second" style="flex-grow: 1; margin: 15px 0" v-show="!showSupportsOutput">
          <div class="jobOptimization" v-if="!(creatingJob || loading3JS)">
            <div v-if="jobOptimization" class="info-text">
              <span class="bold">Optimization: </span>{{jobOptimization}}
            </div>
          </div>
        </div>
        <div style="display: flex" v-show="!showSupportsOutput">
          <div style="align-self: flex-end; padding: 16px; margin-right: 15px"  class="left-panel__box">
            <div>
              <span>Legend lower limit (mm): </span>
              <input type="text" id="legendLowerLimit" />
            </div>
            <div>
              <span>Legend upper limit (mm): </span>
              <input type="text" id="legendUpperLimit" />
            </div>
            <div>
              <button :disabled="false" style="width: 100%" class="btn a3d inv" @click="viewer.applyNewLegendLimit()">Apply new legend limit</button>
            </div>
            <div>
              <button :disabled="false" style="margin: 5px 0 0 0; width: 100%" class="btn a3d inv" @click="viewer.resetLegendLimit()">
                Reset legend limit
              </button>
            </div>
          </div>
          <div style="width: 300px;">
            <div class="left-panel__box">
              <div v-if="isBladeCanCrush" class="caution">{{isBladeCanCrushMessage}}</div>
              <p v-if="isHasOptionsFull">
                <input name="displacementOption"
                      type="radio"
                      id="default-opt"
                      v-model="displacementOption"
                      @change="switchDistortionOption('default')"
                      value="default"/>
                <label for="default-opt">Total distortion (post-support removal to stl)</label>
              </p>
              <p v-if="isHasOptionsFull">
                <input name="displacementOption"
                      type="radio"
                      id="removal-opt"
                      v-model="displacementOption"
                      @change="switchDistortionOption('removal')"
                      value="removal"/>
                <label for="removal-opt">Distortion due to residual stress (post-support removal to as-built part)</label>
              </p>
              <p>
                <input name="displacementOption"
                      type="radio"
                      id="on-opt"
                      v-model="displacementOption"
                      @change="switchDistortionOption('on')"
                      value="on"/>
                <label for="on-opt">Distortion due to build process (as-built to stl)</label>
              </p>
            </div>
            <div class="left-panel__box">
              <p>
                <input name="displacementDirection"
                      type="radio"
                      id="z-dist"
                      v-model="displacementDirection"
                      @change="viewer.switchDistortion('z')"
                      value="z"/>
                <label for="z-dist">Z-Direction Displacement</label>
              </p>
              <p>
                <input name="displacementDirection"
                      type="radio"
                      id="y-dist"
                      v-model="displacementDirection"
                      @change="viewer.switchDistortion('y')"
                      value="y"/>
                <label for="y-dist">Y-Direction Displacement</label>
              </p>
              <p>
                <input name="displacementDirection"
                      type="radio"
                      id="x-dist"
                      v-model="displacementDirection"
                      @change="viewer.switchDistortion('x')"
                      value="x"/>
                <label for="x-dist">X-Direction Displacement</label>
              </p>
              <p v-if="displacementDirectionN">
                <input name="displacementDirection"
                      type="radio"
                      id="n-dist"
                      v-model="displacementDirection"
                      @change="viewer.switchDistortion('n')"
                      value="n"/>
                <label for="n-dist">Displacement normal to part surface</label>
              </p>
            </div>
            <div class="left-panel__box">
              <p>
                <label id="distortionAtSelect">Distortion at select: </label>
              </p>
            </div>
            <div class="legend-block" v-if="legends > 0">
              <div class="inset-legend">
                <div class="filename">{{currentPartName}}</div>
                <div class="legend-title">Distortion [mm]</div>
                <div class="inset-legend-wrp" id="inset-legend-wrp"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
    <router-link class='a3d btn btn-large' style='position:absolute;top: 1em;left: 1em;' :to="{ name: 'Dash' }" v-if="!isNxUser">Back</router-link>
    <div class="overlay" v-if="showOverlay"></div>
    <modal ref="summarymodal" name="summarymodal" :pivotY="0.2" :reset="true" height="auto" width="75%">
      <job-summary :config="config" :jobDescription="jobDescription" :submit="submitInput"></job-summary>
    </modal>
    <modal ref="summarynestedmodal" name="summarynestedmodal" :pivotY="0.2" :reset="true" height="auto" width="40%">
      <div class="prompt-modal">
        <div v-if="!isManualPlacement" class="title">Submit Nested Job?</div>
        <div v-else>
          <div v-if="platesErrors" class="title alert-title">There are some errors on build plates. Submit anyway?</div>
          <div v-else-if="!platesConfig.length" class="title alert-title">You should add plates first</div>
          <div v-else class="title">Submit Nested Job?</div>
          <div class="wrap">
            <div v-for="(plate, index) of platesConfig" class="plate" :key="index">
              <div v-for="(plateName, name) in plate" :key="name">
                <div class="plate-title" v-bind:style="plateName.errors && 'color: red'"> Build {{name}} </div>
                <div v-for="(part, name) in plateName" :key="name">
                  <div v-if="name !== 'errors'">{{name}}  copies: {{part.length / 3}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s6 right-align">
            <button class="a3d btn" @click="submitInput()" :disabled="!platesConfig.length && isManualPlacement">Ok</button>
          </div>
          <div class="col s6 left-align">
            <button class="a3d btn inv" @click="$modal.hide('summarynestedmodal')">Cancel</button>
          </div>
        </div>
      </div>
    </modal>
    <modal ref="modifycaution" name="modifycaution" :pivotY="0.3" :reset="true" height="auto" width="50%">
        <div class="prompt-modal">
            <div class="title">Modifying supports jeopardizes build success. Modified support builds are at user's own risk.</div>
            <div class="row">
                <div class="col s6 right-align">
                    <button class="a3d btn" @click="generateSupportStructures()">Modify</button>
                </div>
                <div class="col s6 left-align">
                    <button class="a3d btn inv" @click="$modal.hide('modifycaution')">Cancel</button>
                </div>
            </div>
        </div>
    </modal>
    <modal ref="dialoghelp" name="dialoghelp" :pivotY="0.3" :reset="true" height="auto" width="50%">
      <div class="dialog-help">
        <p><b>Instructions</b></p>
        <p> The viewer allows the user to choose the unit, scaling factor and orientation of the part and start the AM simulation.</p>
        <ul>
          <li>Choose the unit associated with the STL file.</li>
          <li>Choose the scaling factor of the part, e.g., scaling factor = 1.5 means the printed part is 150% of the orignal size of the STL.</li>
          <li>Change the part orientation by dragging the part or by entering the three Euler angles.</li>
          <li>After the scaling factor and orientation is chosen, uncheck "Orient Model" to generate support structures.</li>
          <li>To choose a different unit, scaling factor or part orientation, check "Orient Model" again.</li>
          <li>The user can reset the view by clicking "Reset View".</li>
          <li>After the unit, scaling factor and orientatoin are decided, click "RUN JOB" to start the job.</li>
        </ul>
        <div class="center-align">
          <button class="a3d btn" @click="$modal.hide('dialoghelp')">Ok</button>
        </div>
      </div>
    </modal>
    <modal ref="zrotationmodal" name="zrotationmodal" :pivotY="0.3" :reset="true" height="auto" width="50%">
      <div class="dialog-help">
        <p>WARNING: By setting the z rotation manually, you may not achieve the best possible density of parts, uncheck the box again to let AM Build Optimizer maximize your part density</p>
        <div class="center-align">
          <button class="a3d btn" @click="changeZRotation(true)">Ok</button>
          <button class="a3d btn" @click="changeZRotation(false)">Cancel</button>
        </div>
      </div>
    </modal>
    <modal ref="removeplatemodal" name="removeplatemodal" :pivotY="0.3" :reset="true" height="auto" width="50%">
      <div class="dialog-help">
        <p>WARNING: There are some nested parts on this build plate. Remove plate anyway?</p>
        <div class="center-align">
          <button class="a3d btn" @click="removePlate(true)">Ok</button>
          <button class="a3d btn" @click="removePlate(false)">Cancel</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<style lang='scss' scoped>
.loading-styles {
  position:relative;
  height:100%;
  width:100%;
}
.preloader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display:flex;
  justify-content:center;
  align-items:center;

  &.overlay {
    background-color: #fff;
  }
}

.a3d.btn.no-wrap {
  white-space: nowrap;
}

#viewport {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #1b1c1e;
  background-image: linear-gradient(#7d8fa3, #1b1c1e);
}

#info, #bottom-legend {
  position: absolute;
}

#info, #bottom-legend, .jobOptimization {
  text-align: center;
  z-index: 100;

  .info-text {
    padding: 8px 24px;
    display: inline-block;
    margin: 0 auto;
    color: #fff;
    background-color: rgba(0, 189, 209, 0.8);
    border:1px solid rgb(0, 189, 209);
    border-radius: 8px;
  }
}

.jobOptimization {
  .info-text {
    padding: 16px 24px;
  }
}

#info {
  top: 1em;
  left: 120px;
  right: 380px;
}

#bottom-legend {
  bottom: 1em;
  margin: 0 100px;
}

#inset  {
  width: 150px;
  height: 150px;
  background-color: transparent; /* or transparent; will show through only if renderer alpha: true */
  border: none; /* or none; */
  margin: 0;
  padding: 0;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 100;
}

.dialog-help {
  padding: 20px;
}

.left-panel, .bottom-block .controls-box {
  p {
    margin: 0.5em 0;
  }

  label {
    color: #fff;
    font-size: 14px;
  }
  [type="radio"]:not(:checked) + label,
  [type="radio"]:checked + label,
  [type="radio"].with-gap:checked + label {
    height: 24px;
    line-height: 24px;
  }
  [type="radio"]:checked + label:after,
  [type="radio"].with-gap:checked + label:before,
  [type="radio"].with-gap:checked + label:after {
    border-color: #fff;
  }

  [type="radio"]:checked + label:after,
  [type="radio"].with-gap:checked + label:after {
    background-color: #fff;
  }

  [type="radio"]:not(:checked) + label:before,
  [type="radio"]:not(:checked) + label:after {
    border-color: #d5d5d5;
  }

  [type="checkbox"] + label {
    margin-left: 4px;
    padding-left: 32px;
  }
  [type="checkbox"]:not(:checked) + label:after {
    border-color: #d5d5d5;
    top: 4px;
    width: 16px;
    height: 16px;
  }
  [type="checkbox"].filled-in:checked + label:after {
    border-color: #fff;
    background-color: #fff;
    top: 4px;
    width: 16px;
    height: 16px;
  }
  [type="checkbox"].filled-in:checked + label:before {
    border-bottom-color: #00BDD1;
    border-right-color: #00BDD1;
    top: 3px;
    width: 6px;
    height: 12px;
  }
}

.left-panel {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 700px;
  right: 0;
  position: absolute;
  padding: 15px;
  align-items: end;
  &__box {
    color: #fff;
    background-color: rgba(0, 189, 209, 0.8);
    border: 1px solid rgb(0, 189, 209);
    border-radius: 8px;
    padding: 0 16px;
    margin-top: 1em;

    & input {
      margin: 0 0 10px 0;
      width: 60px;
      height: 30px;
      padding: 0 5px;
      color: #000000;
      border-style: solid;
      border-width: 1px;
      background: rgb(245, 245, 245);
      border-color: rgb(245, 245, 245);
    }
  }
}

.bottom-block {
  position: absolute;
  width: 300px;
  right: 1em;
  bottom: 200px;
  display: flex;
  flex-direction: column;

  &.single-legend {
    bottom: 140px;
  }

  .controls-box {
    color: #fff;
    background-color: rgba(0, 189, 209, 0.8);
    border: 1px solid rgb(0, 189, 209);
    border-radius: 8px;
    padding: 0 16px;
    margin-top: 1em;
    height: 100%;

    &.modify-supports {
      padding-bottom: 16px;
    }

    .caution {
      margin: 0 -16px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 4px 16px;
      font-weight: bold;
      background-color: #ff4444;
    }

    .range-bar {
      display: flex;
      flex-direction: row;
      .range-bar-slider {
        flex: 3;
        input[type="range"]::-webkit-slider-thumb {
          background-color: #fff;
        }
        input[type="range"]::-moz-range-thumb {
          background-color: #fff;
        }
        input[type="range"]::-ms-thumb {
          background-color: #fff;
        }
      }
      .range-bar-value {
        display: flex;
        flex-direction: column;
        justify-content: right;
        padding-left: 12px;
        input {
          color: #fff;
          border-bottom: none;
          padding-top: 14px;
          width: 50px;
          margin-bottom: 0;

          &:focus {
            border-bottom: none;
            box-shadow: none;
          }
        }
      }
    }
    .button-block {
      padding-bottom: 4px;

      &:last-child {
        padding-bottom: 0;
      }

      .btn {
        width: 100%;
      }
    }
  }
}

.legend-block {
  width: 300px;
  display: flex;
  flex-direction: row-reverse;

  .inset-legend {
    width: 300px;
    height: 150px;
    background-color: transparent; /* or transparent; will show through only if renderer alpha: true */
    border: none; /* or none; */
    margin: 0;
    padding: 0;
    position: relative;

    .filename {
      width: 300px;
      padding: 8px 24px;
      text-align: center;
      word-break: break-all;
      color: #000000;
    }
    .legend-title {
      width: 300px;
      text-align: center;
      color: #000000;
      position: absolute;
      bottom: 0;
    }
    .inset-legend-wrp {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.buttons-block {
  display: flex;
  justify-content: right;

  &.second {
    top: calc(2em + 54px);
  }

  .btn {
    margin-left: 0.5em;
  }

  .browser-default {
    height: 54px;
    min-width: 150px;
    max-width: 400px;
    border: none;
  }
}

.context-menu {
  position: absolute;
  background-color: #fff;
  z-index: 110;
  -webkit-box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.2);

  ul {
    margin: 0;
    border: 1px solid #c5c5c5;

    li {
      a {
        cursor: pointer;
        display: block;
        padding: 8px 16px;
        white-space: nowrap;

        &:hover {
          background-color: #f5f5f5;
        }
      }
    }
  }
}

.prompt-modal {
  padding: 20px;
  .row {
    margin-bottom: 0;
  }
  .title {
    font-size: 1.4em;
    text-align: center;
    padding-bottom: 20px;
  }
  .modal-content {
    padding-bottom: 12px;
  }
  .alert-title {
    color: red;
    margin: 0 15px;
  }
  .wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 20px;
  }
  .plate {
    width: 30%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    ul {
      margin: 0
    }
  }
  .plate-title {
    font-size: 18px;
    font-weight: bolder;
  }
  .plate-error {
    padding: 0 0 0 10px
  }
}
</style>



// WEBPACK FOOTER //
// Viewer.vue?46affee2